export * from '/components/responsive-image/components/ResponsiveImage';
